"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUnit = exports.UNIT_DISPLAY_NAMES = exports.SQUARE_FEET = exports.SQUARE_METERS = exports.INCHES = exports.FEET = exports.CENTIMETERS = exports.METERS = void 0;
exports.METERS = 'meters', exports.CENTIMETERS = 'centimeters', exports.FEET = 'feet', exports.INCHES = 'inches', exports.SQUARE_METERS = 'square_meters', exports.SQUARE_FEET = 'square_feet';
var FEET_PER_METER = 3.281;
var SQUARE_FEET_PER_SQUARE_METER = 10.764;
var INCHES_PER_CENTIMETER = 0.394;
exports.UNIT_DISPLAY_NAMES = (_a = {},
    _a[exports.FEET] = 'feet',
    _a[exports.METERS] = 'meters',
    _a[exports.CENTIMETERS] = 'centimeters',
    _a[exports.SQUARE_FEET] = 'sq. ft',
    _a[exports.SQUARE_METERS] = 'sq. m',
    _a);
function convertUnit(magnitude, fromUnit, toUnit, opts) {
    if (opts === void 0) { opts = { round: 2 }; }
    var result;
    // Converting between the same units always produces the same result
    if (fromUnit === toUnit) {
        return magnitude;
        // One-dimensional units
    }
    else if (fromUnit === exports.FEET && toUnit === exports.METERS) {
        result = magnitude / FEET_PER_METER;
    }
    else if (fromUnit === exports.METERS && toUnit === exports.FEET) {
        result = magnitude * FEET_PER_METER;
    }
    else if (fromUnit === exports.CENTIMETERS && toUnit === exports.INCHES) {
        result = magnitude * INCHES_PER_CENTIMETER;
    }
    else if (fromUnit === exports.INCHES && toUnit === exports.CENTIMETERS) {
        result = magnitude / INCHES_PER_CENTIMETER;
    }
    else if (fromUnit === exports.CENTIMETERS && toUnit === exports.METERS) {
        result = magnitude / 100;
    }
    else if (fromUnit === exports.METERS && toUnit === exports.CENTIMETERS) {
        result = magnitude * 100;
        // Square units
    }
    else if (fromUnit === exports.SQUARE_FEET && toUnit === exports.SQUARE_METERS) {
        result = magnitude / SQUARE_FEET_PER_SQUARE_METER;
    }
    else if (fromUnit === exports.SQUARE_METERS && toUnit === exports.SQUARE_FEET) {
        result = magnitude * SQUARE_FEET_PER_SQUARE_METER;
    }
    else {
        throw new Error("Cannot convert ".concat(magnitude, " ").concat(fromUnit, " into ").concat(toUnit));
    }
    // Optionally round the number
    if (opts.round) {
        var factor = Math.pow(10, opts.round);
        return Math.round(result * factor) / factor;
    }
    else {
        return result;
    }
}
exports.convertUnit = convertUnit;
//# sourceMappingURL=index.js.map